// Week 8 / Day 3 — Условный портфель и диверсификация / Learning Portfolio and Diversification
// Solid Grade 6 math + RU Grade 3–4. Educational model; not financial advice.

export const maxWeek8Day3 = {
  id: 'max-week-8-day-3',
  studentId: 'max',
  weekId: 'week-8',
  dayId: 'day-3',
  title: 'Условный портфель и диверсификация / Learning Portfolio and Diversification',
  shortTitle: 'Портфель и распределение / Portfolio and Split',
  theme:
    'Макс изучает распределение ресурсов между проектами и анализирует изменение учебного портфеля. / Max studies allocation across projects and portfolio change.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через отношение 5:3:2, изменение портфеля, концентрацию и обратный процент. / Nimny walks Max through 5:3:2, portfolio change, concentration and inverse percent.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: отношения, проценты со знаком, концентрация, обратный процент (Grade 6). / ratios, signed percents, concentration, inverse percent.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о распределении + план + 4 предложения.',
    'Слой 4. Наблюдение и логика / Layer 4. Observation and logic: сравнить два распределения.',
    'Слой 5. Практика: свой учебный портфель на 3 проекта. / Practical: own 3-project learning portfolio.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'распределение / allocation', definition: 'как ресурс разделяется по частям / how a resource is split into parts' },
    { term: 'портфель / portfolio', definition: 'набор проектов, между которыми распределён ресурс / a set of projects with allocated resources' },
    { term: 'концентрация / concentration', definition: 'сколько ресурсов лежит в одном проекте / share held in one project' },
    { term: 'изменение / change', definition: 'на сколько выросло или уменьшилось значение / growth or decline' },
    { term: 'обратный процент / inverse percent', definition: 'находим исходное значение по новому и проценту / find whole from new and percent' },
    { term: 'диверсификация / diversification', definition: 'учебная модель: распределяем ресурс между несколькими проектами / spread across several projects' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Распределение 5:3:2 / Split 5:3:2',
      prompt: '240 условных нимов между A, B и C в отношении 5:3:2. Сколько каждому? / Split 240 by 5:3:2.',
      helper: '5 + 3 + 2 = 10; 240 ÷ 10 = 24. / Sum parts, divide.',
      answer: 'A 120; B 72; C 48. / 120 / 72 / 48.', unit: 'нимов / nims' },
    { id: 'q2', type: 'math', title: 'Изменение портфеля / Portfolio change',
      prompt: 'Изменения: A +10%, B −5%, C +12.5%. Начальные: 120/72/48. Найди новые значения, сумму и общий процент изменения. / New values + total + total %.',
      helper: '× (1 + p) для каждого; сумма; сравни с 240. / Multiply and sum.',
      answer: 'A 132; B 68.4; C 54; сумма 254.4; итог +6%. / 132 / 68.4 / 54; total +6%.', unit: '' },
    { id: 'q3', type: 'math', title: 'Концентрация / Concentration',
      prompt: 'A = 120 из 240. Какой процент в A? Лимит на один проект — 40%. Сколько нимов вынести из A? / A share + amount to move.',
      helper: '120 ÷ 240; 40% × 240; вычти. / Percent + limit − actual.',
      answer: 'A = 50%; вынести 24 нима. / 50%; move 24 nims.', unit: '%' },
    { id: 'q4', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'распределение / allocation' },
        { id: 'w2', text: 'учебный / learning (adj)' },
        { id: 'w3', text: 'распределять / to allocate' },
        { id: 'w4', text: 'проект / project' },
        { id: 'w5', text: 'условный / relative' },
        { id: 'w6', text: 'проверять / to check' }
      ] },
    { id: 'q5', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «распределение расурсов памагает уменшить риск, но не гарантируит успех». / Rewrite without mistakes.',
      placeholder: 'Распределение... / Allocation...' },
    { id: 'q6', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Распределение и риск» на печатном листе. Главная мысль, план из 3 пунктов и 4 предложения. / Main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q7', type: 'text', title: 'Сравни два плана / Compare two plans',
      prompt: 'Плана A: все 240 нимов в одном проекте. План B: 120 / 72 / 48 в трёх проектах. Какой более концентрирован? Какой распределяет риск? Гарантирует ли B рост? / 3 questions.',
      placeholder: 'A концентрирован, потому что... / A is concentrated because...' },
    { id: 'q8', type: 'text', title: 'Практика: мой учебный портфель / Practical: my learning portfolio',
      prompt: 'Составь портфель из 3 учебных проектов с ресурсами в отношении 4:3:3 из 200 нимов. Опиши риск каждого и что проверишь. / 3 projects with ratio 4:3:3 of 200.',
      placeholder: 'A: __ нимов (риск __); B: __ (риск __); C: __ (риск __).' },
    { id: 'q9', type: 'essay', title: 'Почему распределение не убирает риск полностью / Why split does not remove all risk',
      prompt: '3–5 предложений: почему даже распределение оставляет часть неопределённости. / 3–5 sentences.',
      minSentences: 3, maxSentences: 6, placeholder: 'Даже если... / Even if...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 8, День 3». / Heading.',
    'Слой 1. Математика: q1–q3 + MATH 4 (обратный процент) из печатного листа. / Math + inverse percent.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: сравнить A и B. / Logic.',
    'Слой 5. Практика: учебный портфель 3 проекта. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 8, День 3 / Week 8, Day 3',
    subtitle: 'Условный портфель и диверсификация / Learning Portfolio and Diversification',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Наблюдение и логика: сравнение планов / Compare plans — 5–10 мин / min.',
          '5. Практика: учебный портфель / Practical: learning portfolio — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: отношения, проценты со знаком, концентрация, обратный процент. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 240 в 5:3:2. 5 + 3 + 2 = ____. 240 ÷ ____ = ____. A: 5 × ____ = ____. B: 3 × ____ = ____. C: 2 × ____ = ____. / Ratio split.',
          '2) A: 120 × 1.10 = ____. B: 72 × 0.95 = ____. C: 48 × 1.125 = ____. Сумма ____. Изменение: 254.4 − 240 = ____ = ____% от 240. / Portfolio %.',
          '3) A = 120 ÷ 240 = ____ = ____%. Лимит 40% × 240 = ____. Вынести из A: 120 − ____ = ____. / Concentration.',
          '4) MATH 4 — Обратный процент: 96 ÷ 1.20 = ____ (исходное значение до роста +20%). / Inverse percent.',
          '5) Проверка / Check: 120 + 72 + 48 = ____ = 240? / Verify ratio.',
          '6) Проверка / Check: 132 + 68.4 + 54 = ____? / Verify portfolio.',
          '7) Optional / Доп.: 12.5% от 48 = ____; сложи с 48: ____. / Extra %.',
          '8) Optional / Доп.: если C вырос ещё на 10%, C = 54 × 1.10 = ____. / Extra growth.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: часть речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: распределение, портфель, проект, концентрация, изменение, условный.',
          'Части речи / Parts of speech: распределение, учебный, распределять, проект, условный, проверять — раздели.',
          'Исправь ошибки / Fix mistakes: «распределение расурсов памагает уменшить риск, но не гарантируит успех».',
          'Вставь букву / Insert vowel: р_спределение, р_сурс, п_ртфель, к_нцентрация.',
          'Мини-диктант / Mini-dictation: «Распределение ресурсов помогает уменьшить риск, но не гарантирует успех».'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Распределение и риск» / Text: Когда ресурс лежит в одном месте, он полностью зависит от одного события. Если это событие пойдёт не так, всё пропадёт. Если ресурс распределён по нескольким проектам, часть может пойти хуже, а часть — лучше, и итог станет спокойнее. Но распределение не превращает риск в ноль: несколько проектов могут одновременно пойти вниз. Поэтому распределение уменьшает риск, но не убирает его полностью. / One place = one event risk. Splitting eases the whole but does not remove risk.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о распределении / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Наблюдение и логика: сравнение планов / Layer 4. Compare plans', blocks: [
        { type: 'text', text: 'Готовое сравнение / Ready comparison:' },
        { type: 'list', items: [
          'План A / Plan A: 240 нимов в одном проекте.',
          'План B / Plan B: 120 / 72 / 48 в трёх проектах.',
          'Какой более концентрирован? / Which is more concentrated? — ____.',
          'Какой распределяет риск? / Which spreads risk? — ____.',
          'Гарантирует ли B положительный результат? / Does B guarantee a positive result? — ____.',
          'Мой вывод / Conclusion: распределение уменьшает риск, но не гарантирует рост. / Spreading eases risk without guarantees.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: учебный портфель / Layer 5. Practical Knowledge: learning portfolio', blocks: [
        { type: 'text', text: 'Учебный портфель. Не реальные инвестиции. / Learning portfolio; not real investing.' },
        { type: 'list', items: [
          '200 нимов; отношение 4:3:3. A: 4 × ____ = ____ ; B: 3 × ____ = ____; C: 3 × ____ = ____. / Split.',
          'Проект A: __________________________________ (риск: ____).',
          'Проект B: __________________________________ (риск: ____).',
          'Проект C: __________________________________ (риск: ____).',
          'Что проверить перед решением / Checks: __________________________________',
          'Условная уверенность 1–10 / Confidence 1–10: ____.'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что я понял про распределение / What I learned about splitting: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за концентрацию и обратный процент / Bonus for concentration + inverse percent: +1 ☐',
          'Бонус за понятный портфель / Bonus for a clear portfolio: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: 5:3:2 из 240 = 120/72/48; портфель: 132/68.4/54, сумма 254.4, итог +6%; концентрация A = 50%, вынести 24; обратный: 96 ÷ 1.20 = 80. Русский Grade 3–4. Учебная модель. / Educational model.',
    mathGoal: 'q1: 120/72/48. q2: 132/68.4/54; +6%. q3: 50%; 24. MATH 4: 80. / Listed with steps.',
    russianGoal: 'Существительные: распределение, проект. Глаголы: распределять, проверять. Прилагательные: учебный, условный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: распределение уменьшает риск, но не убирает. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Учебный портфель 200 в 4:3:3 с рисками. / Learning portfolio 4:3:3 of 200.',
    check: [
      'Q1: 120 / 72 / 48.',
      'Q2: 132 / 68.4 / 54; 254.4; +6%.',
      'Q3: 50%; вынести 24.',
      'MATH 4: 80 нимов.',
      'Q4: части речи разобраны. / Parts of speech.',
      'Q5: исправление чистое. / Correction clean.',
      'Q6: главная мысль + план + 4 предложения. / Reading essentials.',
      'Q7: A концентрирован, B распределяет; B не гарантирует. / Correct comparison.',
      'Q8: 80 / 60 / 60 в проектах. / 4:3:3 of 200.',
      'Q9: 3–5 предложений. / 3–5 sentences.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Ответ: A = 120; B = 72; C = 48 нимов. Решение: 5 + 3 + 2 = 10; 240 ÷ 10 = 24; 5×24=120, 3×24=72, 2×24=48. Подсказка родителю: Проверка: 120 + 72 + 48 = 240.' },
      { taskId: 'q2', answer: 'Ответ: A = 132; B = 68.4; C = 54; сумма 254.4; общий рост +6%. Решение: 120×1.10=132; 72×0.95=68.4; 48×1.125=54; 132+68.4+54=254.4; 14.4 ÷ 240 = 0.06 = +6%. Подсказка родителю: Отрицательный процент одного проекта не делает итог отрицательным.' },
      { taskId: 'q3', answer: 'Ответ: A = 50% портфеля; нужно вынести 24 нима. Решение: 120 ÷ 240 = 0.5 = 50%; лимит 40% × 240 = 96; 120 − 96 = 24. Подсказка родителю: Концентрация — доля одного проекта в общем портфеле.' },
      { taskId: 'q4', answer: 'Ответ: Существительные: распределение, проект. Глаголы: распределять, проверять. Прилагательные: учебный, условный. Решение: Часть речи определяется по вопросу и роли в предложении. Подсказка родителю: Прилагательное отвечает на «какой?»; глагол — на «что делать/делает?».' },
      { taskId: 'q5', answer: 'Ответ: Распределение ресурсов помогает уменьшить риск, но не гарантирует успех. Решение: Исправлены: «расурсов → ресурсов», «памагает → помогает», «уменшить → уменьшить», «гарантируит → гарантирует». Подсказка родителю: Обратите внимание на приставки «по-» и мягкий знак в «уменьшить».' },
      { taskId: 'q6', answer: 'Ответ: Главная мысль: распределение снижает, но не убирает риск. Решение: План: 1) один проект — один риск; 2) распределение сглаживает; 3) общий риск остаётся. + 4 свои предложения. Подсказка родителю: Пересказ 3–5 предложений по-русски.' },
      { taskId: 'q7', answer: 'Ответ: A концентрирован (всё в одном). B распределяет риск (в трёх). B не гарантирует положительный итог. Решение: Достаточно двух наблюдений: концентрация A и распределение B. Подсказка родителю: Ответ должен явно содержать фразу «не гарантирует».' },
      { taskId: 'q8', answer: 'Ответ: Открытый ответ: 4:3:3 из 200 → 80 / 60 / 60; описание проектов и их рисков. Решение: 4 + 3 + 3 = 10; 200 ÷ 10 = 20; 4×20=80, 3×20=60, 3×20=60. Подсказка родителю: Ребёнок должен указать риск для каждого проекта.' },
      { taskId: 'q9', answer: 'Ответ: 3–5 предложений: несколько проектов могут одновременно пойти вниз; риск не становится нулём. Решение: Ожидаемый пример: одновременная просадка A и B. Подсказка родителю: Принимать разные примеры при верной логике.' }
    ],
    logicRubric: 'Принимаются ответы, где ребёнок явно указал, что B не гарантирует рост. / Must include "no guarantee".',
    readingRubric: 'Пересказ 3–5 предложений; главная мысль о снижении, а не устранении риска. / Essentials.',
    parentNotes: [
      'Это учебная модель процентов, распределения и риска, а не финансовая рекомендация. / Educational, not advice.',
      'Обратный процент: делим новое значение на (1 + p) для роста или (1 − p) для снижения. / Inverse rule.',
      'Проверьте, что ребёнок не путает «−5%» с «−5 нимов». / Percent vs absolute.'
    ],
    spellingCheck: 'Части речи и правописание слов темы. / Parts of speech + theme words.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Reading essentials.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Где в жизни ты видел распределение по частям? / Where in life have you seen splitting?',
      'Когда лучше одно, а когда — несколько? / When one is better than many?',
      'Что убирает риск полностью? / What removes risk fully?',
      'Как ты понимаешь «диверсификация»? / How do you define diversification?'
    ],
    ifEasy: 'Усложни: пересчитай портфель для отношения 6:3:1 из 200. / Extend: 6:3:1 of 200.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'concentration-inverse', label: 'Бонус за концентрацию и обратный процент / Bonus for concentration + inverse percent', amount: 1 },
      { id: 'clean-portfolio', label: 'Бонус за понятный портфель / Bonus for a clear portfolio', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q6', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-8', dayId: 'day-2' },
  nextLessonId: 'max-week-8-day-4'
};

export default maxWeek8Day3;
